import { createPinia } from 'pinia';
import useAppStore from './modules/app';
import useUserStore from './modules/user';

export const createStore = () => createPinia();

const pinia = createStore();

export {
  useAppStore,
  useUserStore,
};

export default pinia;
